var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isButton
      ? _c(
          "button",
          {
            staticClass:
              "col pop-up-add-to-cart-button btn btn-primary mt-1 mb-2",
            attrs: {
              type: "button",
              disabled: _vm.isLoading || _vm.disabled || _vm.OrderSampleEnabled
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.addItemToCart()
              }
            }
          },
          [
            _vm.isLoading
              ? _c("span", {
                  staticClass: "spinner-border spinner-border-sm mr-2",
                  attrs: { role: "status" }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("span", {
              staticClass: "png-icon png-icon-icons-glyph--ko-my-basket"
            }),
            _vm._v("\n      " + _vm._s(_vm.buttonText) + "\n  ")
          ]
        )
      : _c(
          "a",
          {
            staticClass: "font-16",
            class: _vm.OrderSampleEnabled ? "text-muted pointer-none" : "",
            attrs: { href: "#addtobasket" },
            on: {
              click: function($event) {
                $event.preventDefault()
                _vm.OrderSampleEnabled ? "" : _vm.addItemToCart()
              }
            }
          },
          [
            _vm.isLoading
              ? _c("span", {
                  staticClass: "spinner-border spinner-border-sm",
                  attrs: { role: "status" }
                })
              : _vm._e(),
            _vm._v("\n    " + _vm._s(_vm.buttonText) + "\n  ")
          ]
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }